module.exports = __webpack_public_path__ + "img/h.2bfc333a.jpg";